export enum BannerVariant {
  Success = 'success',
  Danger = 'danger',
}
